import Cookies from 'js-cookie';

const ENQUIRY_COOKIE = 'enquiryId';
const ENQUIRY_COOKIE_COMPLETE = 'enquiryId_complete';
const COOKIE_EXPIRY_DAYS = 30;

export interface EnquiryCookie {
  enquiryId: string;
  journeyId: string;
  version: string;
}

export const getEnquiryCookie = (): EnquiryCookie | null => {
  const raw = Cookies.get(ENQUIRY_COOKIE);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getCompleteEnquiryCookie = (): EnquiryCookie | null => {
  const raw = Cookies.get(ENQUIRY_COOKIE_COMPLETE);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setEnquiryCookie = (data: EnquiryCookie): void => {
  Cookies.set(ENQUIRY_COOKIE, JSON.stringify(data), {
    expires: COOKIE_EXPIRY_DAYS,
    path: '/',
    sameSite: 'strict'
  });
};

export const removeEnquiryCookie = (): void => {
  Cookies.remove(ENQUIRY_COOKIE, { path: '/' });
  Cookies.remove(ENQUIRY_COOKIE_COMPLETE, { path: '/' });
};

export const setEnquiryCookieComplete = (data: EnquiryCookie): void => {
  Cookies.set(ENQUIRY_COOKIE_COMPLETE, JSON.stringify(data), {
    expires: COOKIE_EXPIRY_DAYS,
    path: '/',
    sameSite: 'strict'
  });
};

export const renameEnquiryCookieToComplete = (): void => {
  const cookie = getEnquiryCookie();
  if (cookie) {
    setEnquiryCookieComplete(cookie);
    Cookies.remove(ENQUIRY_COOKIE, { path: '/' });
  }
}; 